import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useTaxTypes } from 'modules/finance/hooks/useTaxTypes'
import Loading from 'modules/layout/components/Page/Loading'

interface EditTaxRateModalProps {
  taxTypeId: number
  taxRateId: number
  onClose: () => void
}

const DeleteTaxRateModal: React.FC<EditTaxRateModalProps> = ({ taxTypeId, taxRateId, onClose }) => {
  const { deleteTaxRate } = useTaxTypes()

  const [loading, setLoading] = React.useState<boolean>(false)

  const handleSubmited = async () => {
    setLoading(true)
    const response = await deleteTaxRate(taxTypeId, taxRateId)

    const result = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('finance.settings.taxes.tax_type.delete_tax_rate_modal.messages.error'),
      })
      track(trackingEvents.accounting.deleteValue, {
        status: 'Error',
        tax_type_id: taxTypeId,
        tax_rate_it: taxRateId,
      })
      setLoading(false)
    })

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('finance.settings.taxes.tax_type.delete_tax_rate_modal.messages.success'),
      })
      track(trackingEvents.accounting.deleteValue, {
        status: 'Success',
        tax_type_id: taxTypeId,
        tax_rate_it: taxRateId,
      })
      onClose()
    }
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('finance.settings.taxes.tax_type.delete_tax_rate_modal.title')}
      description={i18n.t('finance.settings.taxes.tax_type.delete_tax_rate_modal.description')}
      onClose={onClose}
      onSubmit={handleSubmited}
      footer={
        <Button disabled={loading} submit>
          {i18n.t('finance.settings.taxes.tax_type.delete_tax_rate_modal.buttons.delete_tax')}
        </Button>
      }
    >
      {loading && <Loading />}
    </Modal>
  )
}

export default observer(DeleteTaxRateModal)
